module.exports = __webpack_public_path__ + "static/media/main-horizontal.a83d19d7.jpg";